import { $auth } from "@/plugins/auth"
import type { NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from "vue-router"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"

export default class Authorized implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if (!$auth.user) {
      return cancel(route(ROUTES.LOGIN))
    }

    // add role checks here

    await next(to, from, cancel)
  }
}
